var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#017C6B",
    fillRule: "evenodd",
    d: "M5.442 4.5a.305.305 0 0 1 .301.254l1.855 10.902a1.806 1.806 0 0 0 1.78 1.503h6.978a.75.75 0 0 0 0-1.5H9.378a.305.305 0 0 1-.301-.254L7.222 4.502A1.806 1.806 0 0 0 5.442 3H4.75a.75.75 0 0 0 0 1.5zM9.762 18.473a1.014 1.014 0 1 1 0 2.027 1.014 1.014 0 0 1 0-2.027M15.168 18.473a1.014 1.014 0 1 1 0 2.027 1.014 1.014 0 0 1 0-2.027",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#017C6B",
    fillRule: "evenodd",
    d: "M18.71 7.66H6.872a.75.75 0 0 1 0-1.5h12.122a1.278 1.278 0 0 1 1.24 1.587l-1.02 4.08a2.86 2.86 0 0 1-2.774 2.166H7.948a.75.75 0 0 1 0-1.5h8.49a1.36 1.36 0 0 0 1.32-1.03z",
    clipRule: "evenodd"
  })));
};
export default SvgCart;